import request from '@/utils/request';

// 路救申请信息列表
export function getApplyList(data, params) {
  return request({
    url: '/bak/roadRescue/pageList',
    method: 'post',
    data,
    params: params
  });
}

// 跟据案件号获取路救申请信息
export function getApplyRecord(caseId) {
  return request({
    url: '/roadRescue/getApplyRecord',
    method: 'get',
    params: {caseId}
  });
}

// 跟据案件号获取案件状态信息
export function getApplyStatus(caseId) {
  return request({
    url: '/roadRescue/applyStatus',
    method: 'post',
    params: {caseId}
  });
}

